import React from 'react';
import Image from 'next/image';
import CreateResumeBtn from './CreateResumeBtn';
import DiagnosisImage from '@/assets/resume-marketing/diagnosis.png';

const ResumeDiagnosis = () => {
  return (
    <div
      className="my-20 px-5 tablet:my-25"
      data-ele-id="content"
      data-ele-group="landing_简历诊断，发现提升点，赢在起点"
      data-observer-id="landing_简历诊断，发现提升点，赢在起点"
    >
      <div className="text-center">
        <p className="text-3.25xl font-semibold mb-3 tablet:text-4pxl">
          简历诊断，发现提升点，赢在起点
        </p>
        <p className="text-lg text-black/65 mb-5">
          通过深入诊断，精准定位改进方向，让您的简历更具竞争力
        </p>
        <CreateResumeBtn dataEleGroup="landing_简历诊断，发现提升点，赢在起点" />
      </div>
      <div className="w-full px-10.25 mx-auto overflow-hidden mt-12 pt-2 rounded-lg [background:linear-gradient(110.88deg,#fff5f6_0.74%,#e6ebf2_98.01%)] tablet:w-[1254px] tablet:pt-[33px] tablet:rounded-2.5xl">
        <div className="w-full tablet:ml-[303px] tablet:max-w-[780px]">
          <Image
            src={DiagnosisImage}
            alt=""
            style={{
              objectFit: 'contain',
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default ResumeDiagnosis;
